export async function consumeSSE(
  res: Response,
  onEvent: (event: string, data: string) => void | Promise<void>,
): Promise<void> {
  const reader = res.body!.getReader();
  const decoder = new TextDecoder();
  let buf = "";

  try {
    while (true) {
      const { done, value } = await reader.read();
      if (done) break;
      buf += decoder.decode(value, { stream: true });
      while (buf.includes("\n\n")) {
        const idx = buf.indexOf("\n\n");
        const block = buf.slice(0, idx);
        buf = buf.slice(idx + 2);
        let event = "",
          data = "";
        for (const line of block.split("\n")) {
          if (line.startsWith("event: ")) event = line.slice(7);
          else if (line.startsWith("data: ")) data = line.slice(6);
        }
        if (event) await onEvent(event, data);
      }
    }
  } finally {
    try {
      await reader.cancel().catch(() => {});
    } finally {
      reader.releaseLock();
    }
  }
}

// Turn streams require a successful terminal event; a clean socket EOF is not success.
export async function consumeTurnSSE(
  res: Response,
  onEvent: (event: string, data: string) => void | Promise<void>,
): Promise<void> {
  let completed = false;
  await consumeSSE(res, async (event, data) => {
    if (event === "error") {
      const error = JSON.parse(data);
      const message = typeof error.message === "string" ? error.message : "模型回复生成失败";
      const code = typeof error.code === "string" ? `（${error.code}）` : "";
      const id = error.generation_id || error.request_id;
      throw new Error(`${message}${code}${typeof id === "string" ? ` 请求编号：${id}` : ""}`);
    }
    if (event === "done") {
      const done = JSON.parse(data);
      if (typeof done.reply !== "string" || !done.reply.trim()) {
        throw new Error("模型未返回正文，本轮回复未完成。");
      }
      completed = true;
    }
    await onEvent(event, data);
  });
  if (!completed) throw new Error("回复连接提前结束，本轮回复未完成，请重试。");
}
